import { IonContent, IonInput, IonPage, IonText, IonTextarea,IonSpinner } from "@ionic/react"
import Head from "./Header";
import Sidebar from "./Sidebar";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import { calendar } from 'ionicons/icons';
// import DatePicker from "react-datepicker";

import service from "../Service/service";
import DataTable from "react-data-table-component";
import moment from "moment";
import swal from 'sweetalert';
import { Modal } from "react-bootstrap";
import { error } from "console";

const LeaveHistory = () => {
      const history = useHistory();
      const [Id] = useState(localStorage.getItem("SignupEmpId"));
      useEffect(() => {
            if (Id === null) {
                  history.push("/login");
            } else {
            }
      }, [Id, history]);

      const [id] = useState(localStorage.getItem("SignupEmpId"));
      const [fromDate, setFromDate] = useState("");
      const [toDate, setToDate] = useState("");
      const [loading,setloading]=useState(false)
      const [data, setData] = useState([]);

      data.forEach((item: any, index: any) => { item.serial = index + 1; });

      const [filterText, setFilterText] = useState("");
      const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
      /*.................... View ..................*/
      const [modalopen, setModalopen] = useState(false);

      const [leaveType, setLeaveType] = useState("");
      const [status, setStatus] = useState("");
      const [fDate, setFDate] = useState("");
      const [empName, setEmpName] = useState("");
      const [tDate, setTDate] = useState("");
      const [leaveReason, setLeaveReason] = useState("");
      const [reportingPerson, setReportingPerson] = useState("");
      const [NoOfDays, setNoOfDays] = useState("");
      const [remarks, setRemarks] = useState("");

      //-------------------search Date Api----------------//

      useEffect(() => {
            Search();
      }, []);
      const Search = () => {
            setloading(true);
            service.GetEmployeeLeaveHistory(fromDate, toDate, id)
                .then((response) => {
                    console.log(response);
                    if (response.data.status === 200) {
                        setData(response.data.data);
                    } else {
                        setData([]);
                        swal("", response.data.message, "error");
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    // This code will execute whether the promise is resolved or rejected
                    setTimeout(() => {
                        setloading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
                    }, 500); // Adjust the timeout duration as needed
                });
        };

      //------------------Search Filter------------------//

      const datatable = data.filter(
            (item: any) =>
                  JSON.stringify(item)
                        .toLowerCase()
                        .indexOf(filterText.toLowerCase()) !== -1
      );

      const paginationComponentOptions = {
            selectAllRowsItem: true,
            selectAllRowsItemText: "ALL"
      };
      const subHeaderComponent = useMemo(() => {
            const handleClear = () => {
                  if (filterText) {
                        setResetPaginationToggle(!resetPaginationToggle);
                        setFilterText("");
                  }

            };

            return (
                  <div style={{ display: "flex" }}>
                        <div style={{ display: "flex" }}>
                              <div className="form-group form-focus row">
                                    <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                                          value={filterText} placeholder="Search" />
                                    <label className="focus-label">Search</label>
                              </div>
                              <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                        </div>
                  </div>
            )

      }, [filterText, resetPaginationToggle]);

      //----------------------LeaveHistory Datatable---------------//

      const columns: any = [
            {
                  name: "S.No",
                  selector: (itm: any, i: any) => itm.serial,
                  sortable: true,
                  width: "100px",
            },
            {
                  name: "Employee Name",
                  sortable: true,
                  width: "250px",
                  cell: (itm: any) => (
                        <>
                              <div>{itm.empName}{" ("}{itm.empCode}{")"}</div>
                        </>
                  )
            },
            {
                  name: "Leave Type ",
                  selector: (itm: any) => itm.leaveType.leaveType,
                  sortable: true,
            },
            {
                  name: "From Date",
                  selector: (itm: any) => moment(itm.fromDate).format("DD-MM-YYYY"),
                  sortable: true,
                  // width: "150px"
            },
            {
                  name: "To Date",
                  selector: (itm: any) => moment(itm.toDate).format("DD-MM-YYYY"),
                  sortable: true,
                  // width: "150px"
            },
            {
                  name: "No Of Days",
                  selector: (itm: any) => itm.noOfDays,
                  sortable: true,
                  // width: "100px"
            },
            {
                  name: "Status",
                  sortable: true,
                  cell: (itm: any) => (
                        <>
                              <IonText className={itm.leaveStatus.status === "Approved" ? "color_approve" : itm.leaveStatus.status === "Open" ? "color_progress" : "color_deny"}>{itm.leaveStatus.status}</IonText>
                        </>
                  )
            },
            {
                  name: "Action",
                  sortable: false,
                  cell: (itm: any) => (
                        <>
                              <div style={{ textDecoration: 'underline', textDecorationColor: "coral", textUnderlinePosition: "under" }}>
                                    <IonText onClick={() => View(itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                              </div>
                        </>
                  )
            }
      ];

      const customStyles = {
            headRow: {
                  style: {
                  },
            },
            headCells: {
                  style: {
                        fontWeight: "bold",
                        fontSize: "15px",
                        justifyContent: "center"
                  },
            },
            cells: {
                  style: {
                        fontSize: "16px",
                        justifyContent: "center"
                  }
            }
      };

      //------------------------View Api------------------------//

      const View = (id: any) => {
            setModalopen(true)
            service.GetLeaveDetailsById(id)
                  .then((response) => {
                        console.log(response, "lmlml")
                        if (response.data.Status === "200") {
                              setLeaveType(response.data.Data.leaveType.leaveType);
                              setStatus(response.data.Data.leaveStatus.status);
                              setFDate(response.data.Data.fromDate);
                              setTDate(response.data.Data.toDate);
                              setEmpName(response.data.Data.empName)
                              setLeaveReason(response.data.Data.reason);
                              setReportingPerson(response.data.Data.reportingPerson[0])
                              setNoOfDays(response.data.Data.noOfDays);
                              setRemarks(response.data.Data.remarks);
                        }
                  })
                  .catch((error) => {
                        console.log(error)
                  })
      }

      const closemodal = () => {
            setModalopen(false);
            setLeaveType("");
            setStatus("");
            setFromDate("");
            setTDate("");
            setFDate("");
            setLeaveReason("");
            setReportingPerson("");
            setNoOfDays("");
            setRemarks("");
      }
      const back = () => {
            history.goBack();
      }
      return (
            <IonPage>
                  <Head />
                  <Sidebar />
                  <IonContent>
                        <div className="page-wrapper">
                              <div className="page-header">
                                    <div className="content container-fluid">
                                          <div className="row align-items-center">
                                                <div className="col">
                                                      <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                                            <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                                            Employee Leave History</h3>
                                                </div>
                                          </div>
                                          <div className="row filter-row" style={{ marginTop: "3%" }}>
                                                <div className="col-sm-4 col-md-4">
                                                      <div className="form-group">
                                                            <label style={{ fontWeight: "bold" }}> From Date <span className="text-danger">*</span></label>
                                                            <div>
                                                                  <IonInput type="date" onIonChange={(e: any) => setFromDate(e.detail.value)} className="form-control datetimepicker" />
                                                            </div>
                                                      </div>
                                                </div>
                                                <div className="col-sm-4 col-md-4">
                                                      <div className="form-group">
                                                            <label style={{ fontWeight: "bold" }}> To Date <span className="text-danger">*</span></label>
                                                            <div>
                                                                  <IonInput type="date" onIonChange={(e: any) => setToDate(e.detail.value)} className="form-control datetimepicker" />
                                                            </div>
                                                      </div>
                                                </div>
                                                <div className="col-sm-4 col-md-4" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                                      <a onClick={() => Search()} className="btn btn-success btn-block w-100"> Search </a>
                                                </div>
                                          </div>

                                          {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                                          <div className="table-responsive">
                                                <DataTable
                                                      columns={columns}
                                                      data={datatable}
                                                      pagination
                                                      paginationPerPage={10}
                                                      paginationComponentOptions={paginationComponentOptions}
                                                      paginationRowsPerPageOptions={[10, 20, 30]}
                                                      subHeader
                                                      subHeaderComponent={subHeaderComponent}

                                                      customStyles={customStyles}
                                                />
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <Modal
                              dialogClassName="my-modal modal-dialog-centered"
                              // id="logouts-modal"
                              show={modalopen}
                        >
                              <div className="modal-header">
                                    <h5 className="modal-title">View Leave</h5>
                                    <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                                          <span aria-hidden="true">×</span>
                                    </button>
                              </div>
                              <div className="modal-body">
                                    <form>
                                          <div className="col-md-12">
                                                <div className="row">
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}> Employee Name </label>
                                                                  <div>
                                                                        <IonInput value={empName} readonly className="form-control" />
                                                                  </div>
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>Leave Type </label>
                                                                  <div>
                                                                        <IonInput value={leaveType} readonly className="form-control" />
                                                                  </div>
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>From Date </label>
                                                                  <div>
                                                                        <IonInput value={fDate} readonly className="form-control datetimepicker" type="date" />
                                                                  </div>
                                                            </div>
                                                      </div>
                                                     
                                                </div>
                                                <div className="row">
                                                <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>To Date </label>
                                                                  <div>
                                                                        <IonInput value={tDate} readonly className="form-control datetimepicker" type="date" />
                                                                  </div>
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>No Of Days </label>
                                                                  <IonInput value={NoOfDays} readonly className="form-control" />
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>Status </label>
                                                                  <div>
                                                                        <IonInput value={status} readonly className="form-control" />
                                                                  </div>
                                                            </div>
                                                      </div>

                                                      
                                                </div>
                                                <div className="row">
                                                <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>Reason for Leave </label>
                                                                  <IonInput value={leaveReason} readonly className="form-control" />
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>Reporting Person's </label>
                                                                  <IonInput value={reportingPerson} readonly className="form-control" />
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>Remarks </label>
                                                                  <IonInput value={remarks} readonly className="form-control" />
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                          <div className="row" style={{ marginTop: "5%" }}>
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                      <button type="button" className="btn-primary submit-btn" onClick={() => closemodal()}>Back</button>
                                                </div>
                                          </div>
                                    </form>
                              </div>
                        </Modal>
                  </IonContent>
            </IonPage>
      )
}

export default LeaveHistory;